// extracted by mini-css-extract-plugin
export default {"cardItem":"user_cardItem__rEfj7"};